import { ProductSettingsKeysEnum as Keys } from '../../../../types/product';

export const PRODUCT_SCHEDULE_KEYS = [Keys.IS_HIDE_ALL_QUANTITY_SCHEDULE, Keys.IS_HIDE_PUNCHPASS_SCHEDULE];
